import AvailableToFutureActions from "./AvailableToFutureActions";

const RecordCreateUpdateAdditional = ({ action, setAction }) => {
  return (
    <>
      <AvailableToFutureActions
        available={action?.AvailableToFutureActions}
        setAction={setAction}
      />
    </>
  );
};

export default RecordCreateUpdateAdditional;
